import { Component, Input } from "@angular/core";

interface Filter {
  property: string;
  value: string;
}

@Component({
  selector: "filter-display",
  templateUrl: "./filter-display.html",
  standalone: false,
})
export class FilterDisplay {
  @Input() filters: Filter[];
}
